module.exports = __webpack_public_path__ + "img/coat-of-arm.3dae02bc.jpg";